/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Meta_DescriptionInputs */

const ja_company_meta_description = /** @type {(inputs: Company_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーンは2016年創業、東京を拠点とするゲームマーケティング・eスポーツ制作会社です。日本・アジアに加え、欧米市場へのマーケティング支援も行っています。`)
};

const en_company_meta_description = /** @type {(inputs: Company_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Founded in Tokyo in 2016, PLAYBRAIN is a game marketing agency specializing in Japan and Asia. We help publishers, developers, and gaming brands grow through marketing, esports production, and creative services.`)
};

/**
* | output |
* | --- |
* | "Founded in Tokyo in 2016, PLAYBRAIN is a game marketing agency specializing in Japan and Asia. We help publishers, developers, and gaming brands grow through..." |
*
* @param {Company_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const company_meta_description = /** @type {((inputs?: Company_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_meta_description(inputs)
	return en_company_meta_description(inputs)
});